import { z } from "zod";
import { parameterSchema } from "./parameter.schema";

export const parametersSchema = z.array(parameterSchema);
